import { gql } from '@apollo/client';

export interface GetRadicalDeformationsResponse {
    radicalDeformations: {
        id: string;
        locale: string;
        code: string;
        character: string;
        radical: {
            radical: string;
        };
    }[];
}

export interface GetRadicalDeformationsVariables {
    orderBy: { strokeCount: 'asc' | 'desc' }[];
    where?: {
        locale?: { equals: string };
        OR?: [{ character: { equals: string } }, { radical: { radical: { equals: string } } }];
    };
}

export const GET_RADICAL_DEFORMATIONS = gql`
    query RadicalDeformations($orderBy: [RadicalDeformationOrderByInput!]!, $where: RadicalDeformationWhereInput) {
        radicalDeformations(orderBy: $orderBy, where: $where) {
            id
            locale
            code
            character
            radical {
                radical
            }
        }
    }
`;
